/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Components/AboutProject/AddDescriptionUpsell" />
import * as React from "react";
import * as Resources from "TFS/Views/ProjectOverviewPage/Resources";
import { Button } from "VSSUI/Button";
import { Card } from "VSSUI/Card";
import { Image } from "VSSUI/Image";

export interface AddDescriptionUpsellProps {
    showEditOption: boolean;
    imageLocation: string;
    onAddDescriptionClick: () => void;
    aboutProjectTitleId: string;
}

export const AddDescriptionUpsell = (props: AddDescriptionUpsellProps): JSX.Element => {
    return (
        <Card className={"project-overview-card"}>
            <div className="project-overview-card-container add-description-upsell" role="region" aria-labelledby={props.aboutProjectTitleId}>
                <div className="upsell-title title-m" role="heading" aria-level={2} id={props.aboutProjectTitleId}>
                    {Resources.AboutProjectTitle}
                </div>
                <div className="upsell-content flex">
                    <div className="upsell-left-content flex flex-column">
                        <div className="upsell-heading title-xs">
                            {props.showEditOption ? Resources.AboutProjectUpsellHeading : Resources.AboutProjectUpsellHeading_NoPermission}
                        </div>
                        <div className="upsell-message font-size-m">
                            {props.showEditOption ? Resources.AboutProjectUpsellMessage : Resources.AboutProjectUpsellMessage_NoPermission}
                        </div>
                        {props.showEditOption && (
                            <Button
                                className="upsell-add-button"
                                onClick={props.onAddDescriptionClick}
                                iconProps={{ iconName: "Add" }}
                                text={Resources.AboutProjectUpsellButtonText}
                            />
                        )}
                    </div>
                    <div className="upsell-right-image">
                        <Image src={props.imageLocation} alt="" />
                    </div>
                </div>
            </div>
        </Card>
    );
};
